import { Section, Media, Step, ArrowLink, RuleList } from '../ui';
import { ENGAGE } from '../content';

export default function Services() {
  return (
    <main>
      <Section lg>
        <span className="eyebrow">Services</span>
        <h1 className="h-page" style={{ maxWidth: '22ch' }}>
          Two capabilities, one operation.
        </h1>
        <p className="lede">
          Wanda captures the imagery and builds the intelligence that reads it. Engage either side
          on its own, or run both as a single pipeline.
        </p>
      </Section>

      <Section>
        <div className="grid-rule" style={{ '--min': '320px' }}>
          <div className="card" style={{ padding: 'clamp(26px, 3vw, 40px)' }}>
            <span className="eyebrow eyebrow--accent">01</span>
            <h2 className="h-sub" style={{ margin: '20px 0 14px' }}>
              Flight Operations &amp; Image Capture
            </h2>
            <p className="body" style={{ fontSize: 15.5, marginBottom: 26 }}>
              Mission planning, waivers, flight execution, and data delivery for inspection and
              monitoring programs.
            </p>
            <div style={{ marginBottom: 28 }}>
              <RuleList
                items={[
                  'Utility and energy asset inspection',
                  'VLOS, BVLOS, remote and dock-enabled flight',
                  'Orthomosaic, thermal, and high-resolution stills',
                  'Nationwide crews and program management'
                ]}
              />
            </div>
            <ArrowLink to="/services/flight">Explore flight solutions</ArrowLink>
          </div>

          <div className="card" style={{ padding: 'clamp(26px, 3vw, 40px)' }}>
            <span className="eyebrow eyebrow--accent">02</span>
            <h2 className="h-sub" style={{ margin: '20px 0 14px' }}>
              AI and Machine Learning
            </h2>
            <p className="body" style={{ fontSize: 15.5, marginBottom: 26 }}>
              Custom computer vision models and the applications that put their output in front of
              the people who act on it.
            </p>
            <div style={{ marginBottom: 28 }}>
              <RuleList
                items={[
                  'Defect detection and condition assessment',
                  'Object classification and tracking',
                  'Annotation, training, and model evaluation',
                  'Deployment into review and reporting workflows'
                ]}
              />
            </div>
            <ArrowLink to="/services/visual-intelligence">Explore visual intelligence</ArrowLink>
          </div>
        </div>
      </Section>

      <Section alt>
        <div className="split">
          <div>
            <span className="eyebrow">One capability or the complete workflow</span>
            <h2 className="h-sub" style={{ margin: '16px 0 28px' }}>
              Meet us where you are.
            </h2>
            <div className="grid-plain" style={{ '--min': '100%', gap: 0 }}>
              {ENGAGE.map((e) => (
                <div className="step" key={e.n} style={{ marginBottom: 18 }}>
                  <h3 style={{ margin: '0 0 8px', fontSize: 17 }}>{e.n}</h3>
                  <p className="body body--sm">{e.d}</p>
                </div>
              ))}
            </div>
          </div>
          <Media
            src="/assets/drone-inspire.jpg"
            alt="Inspection aircraft in flight beneath an overcast sky"
            ratio="4x3"
            caption="Flight operations — field deployment"
          />
        </div>
      </Section>

      <Section>
        <h2 className="h-sub" style={{ marginBottom: 40 }}>
          How we engage
        </h2>
        <div className="grid-plain" style={{ '--min': '240px', gap: 28 }}>
          <Step n="Step 01" title="Scope the problem">
            What needs to be seen, how often, and what decision follows.
          </Step>
          <Step n="Step 02" title="Pilot the workflow">
            A bounded capture and analysis run to validate approach and accuracy.
          </Step>
          <Step n="Step 03" title="Scale the program">
            Recurring operations, model retraining, and reporting at program scale.
          </Step>
        </div>
      </Section>
    </main>
  );
}
